import request from '@/http/request';

export function getBillSiteStaff(data) {
  return request({
    url: '/api/v1/ops/bill_site_staff',
    method: 'post',
    data: data,
  });
}

export function innerCheckBillUpload(data) {
  return request({
    url: '/api/v1/ops/inner_check_bill_upload',
    method: 'post',
    data: data,
  });
}

export function confirmBill(data) {
  return request({
    url: '/api/v1/ops/confirm_bill',
    method: 'post',
    data: data,
  });
}

export function submitCheckBillToTx(data) {
  return request({
    url: '/api/v1/ops/submit_check_bill_toTx',
    method: 'post',
    data: data,
  });
}

export function autoCheckBill(data) {
  return request({
    url: '/api/v1/ops/auto_check_bill',
    method: 'post',
    data: data,
  });
}


export function dispatchCheckTicket(data) {
  return request({
    url: '/api/v1/ops/dispatch_check_ticket',
    method: 'post',
    data: data,
  });
}

export function getBillSpecialWork(data) {
  return request({
    url: '/api/v1/ops/bill_special_work',
    method: 'post',
    data: data,
  });
}

export function getNetworkBillList(params) {
  return request({
    url: '/api/v1/ops/network_bill/list',
    method: 'get',
    params,
  });
}

export function getNetworkBillListAll(params) {
  return request({
    url: '/api/v1/ops/network_bill/list/all',
    method: 'get',
    params,
  });
}
